import { render, staticRenderFns } from "./StageCrudSummaryFields.vue?vue&type=template&id=5fbd2e56"
import script from "./StageCrudSummaryFields.vue?vue&type=script&lang=js"
export * from "./StageCrudSummaryFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports